import React, { useState, useEffect } from 'react';
import ScreenHeader from '../ScreenHeader/ScreenHeader';
import DisplayScreen, { DisplayState } from '../DisplayScreen/DisplayScreen';
import { useCarSortationSSE } from '../../hooks/useCarSortationSSE';
import { CarData } from '../CarInfo/CarInfo';

import './CarSortationReal.css';

interface CarSortationRealProps {
  title?: string;
}

const CarSortationReal: React.FC<CarSortationRealProps> = ({ title }) => {
  const defaultTitle = `Tracker Leak Detection`;
  const url = 'https://vw-poc.lotvision.cognosos.net';

  const [currentState, setCurrentState] = useState<DisplayState>('READY');
  const [currentCarData, setCurrentCarData] = useState<CarData | null>(null);

  const { currentCar } = useCarSortationSSE(`${url}/sortation`);

  useEffect(() => {
    if (currentCar) {
      const incomingState: DisplayState =
        currentCar.designation === 'READY'
          ? 'READY'
          : currentCar.designation === 'Lora OBD detected'
          ? 'Lora OBD detected'
          : 'READY';

      setCurrentState(incomingState);
      setCurrentCarData(currentCar);
    }
  }, [currentCar]);

  return (
    <div className={`car-sortation-real`} data-testid="car-sortation-real">
      <ScreenHeader title={title || defaultTitle} />
      <DisplayScreen state={currentState} carData={currentCarData} />
    </div>
  );
};

export default CarSortationReal;
